<app-card title="Declaration of Consent" class="consent-form">
  <p>
    I agree that my usage behavior on this website will be recorded and my CO₂
    footprint calculated. The data collected will be anonymized and used
    exclusively for scientific research purposes.
  </p>
  <p>
    With continuing I confirm that I have read and agree to the
    <a href="/privacy-statements" target="_blank" rel="noopener noreferrer"
      >Privacy Statements</a
    >.
  </p>
  <p>
    If you do not agree, you can delete your profile from this app below. Your SWITCH Account will not be affected by this action.
  </p>

  <div class="button-container">
    <button
      class="btn btn-delete"
      (click)="onCancel(); $event.preventDefault()"
    >
      <app-icon name="trash" color="white"></app-icon>
      Delete profile
    </button>
    <button class="btn" color="green" (click)="onConfirm()">
      <app-icon name="check" color="white"></app-icon>
      Confirm consent
    </button>
  </div>
</app-card>
